// extracted by mini-css-extract-plugin
export default {"Horizontal30pct30pct30pct":"Horizontal30pct30pct30pct_Horizontal30pct30pct30pct__63i99"};